import { render } from "./TableBucketQuickCheck.vue?vue&type=template&id=743e1651&scoped=true"
import script from "./TableBucketQuickCheck.vue?vue&type=script&lang=js"
export * from "./TableBucketQuickCheck.vue?vue&type=script&lang=js"

import "./TableBucketQuickCheck.vue?vue&type=style&index=0&id=743e1651&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Gerente de TI\\Downloads\\temp\\JB\\new-project\\jb-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-743e1651"]])

export default __exports__